import { makeRestApiRequest, RestApiRequestConfig } from '~src/httpClient/RestApiService';

import { IGetIntegrationsForSiteParams } from '../../types/credentials/IGetIntegrationsForSiteParams';
import { IGetIntegrationsForSiteResponse } from '../../types/credentials/IGetIntegrationsForSiteResponse';

export function getSlackIntegrationsForSite(params: IGetIntegrationsForSiteParams): Promise<IGetIntegrationsForSiteResponse> {
  const config: RestApiRequestConfig<{}, IGetIntegrationsForSiteParams> = {
    restApiVersion: '-',
    httpMethod: 'GET',
    endpoint: 'integrations/siteIntegrations',
    serverWideRequest: true,
    queryParams: params,
    requestBody: {},
  };

  return makeRestApiRequest<{}, IGetIntegrationsForSiteResponse, IGetIntegrationsForSiteParams>(config);
}

export function getMsTeamsIntegrationsForSite(params: IGetIntegrationsForSiteParams): Promise<IGetIntegrationsForSiteResponse> {
  const config: RestApiRequestConfig<{}, IGetIntegrationsForSiteParams> = {
    restApiVersion: '-',
    httpMethod: 'GET',
    endpoint: 'integrations/siteIntegrations',
    serverWideRequest: true,
    queryParams: params,
    requestBody: {},
  };

  return makeRestApiRequest<{}, IGetIntegrationsForSiteResponse, IGetIntegrationsForSiteParams>(config);
}